import { all, fork } from 'redux-saga/effects';

import notificationsSaga from 'notifications/notificationsSaga';
import agentProfileSaga from 'agent-profile/agentProfileSaga';
import applicationsDashboardSaga from 'applications-dashboard/applicationsDashboardSaga';

import appSaga from './appSaga';

export default function* rootSaga() {
  yield all([
    fork(appSaga),
    fork(notificationsSaga),
    fork(agentProfileSaga),
    fork(applicationsDashboardSaga),
  ]);
}
